import React from 'react';
import { FaSync, FaSearch, FaTimes, FaCalendarAlt } from 'react-icons/fa';

const STATUS_LABELS = {
    pending: 'Pending',
    partially_approved: 'Partially approved',
    approved: 'Approved',
    rejected: 'Rejected',
    all: 'All',
};

const PurgatoryToolbar = ({
    staging = false,
    onStage,
    onViewReports,
    selectedStatus = 'pending',
    onStatusChange,
    searchQuery = '',
    onSearchChange,
    countFor,
    statuses = ['pending', 'partially_approved', 'approved', 'rejected', 'all'],
}) => {
    return (
        <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            border: '1px solid #e2e8f0',
            padding: '20px',
            marginBottom: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }}>
            {/* Top Row: Title, Subtitle, and Stage Button */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '18px',
            }}>
                <div>
                    <h2 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: '700',
                        color: '#2d3748',
                    }}>
                        Review employee updates
                    </h2>
                    <p style={{
                        margin: '4px 0 0 0',
                        fontSize: '13px',
                        color: '#718096',
                    }}>
                        Review incoming candidate records staged from Onboarding360 before applying changes.
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {onViewReports && (
                        <button
                            type="button"
                            onClick={onViewReports}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                backgroundColor: '#ffffff',
                                color: '#176B64',
                                border: '1px solid #176B64',
                                padding: '10px 16px',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.15s ease',
                            }}
                        >
                            <FaCalendarAlt style={{ fontSize: '13px' }} />
                            <span>Monthly Reports & Licences</span>
                        </button>
                    )}

                    <button
                        type="button"
                        onClick={onStage}
                        disabled={staging}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: staging ? '#a0aec0' : '#2b6cb0',
                            color: '#ffffff',
                            border: 'none',
                            padding: '10px 18px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: staging ? 'not-allowed' : 'pointer',
                            transition: 'background-color 0.15s ease',
                            boxShadow: '0 2px 4px rgba(43, 108, 176, 0.2)',
                        }}
                    >
                        <FaSync className={staging ? 'fa-spin' : ''} style={{ fontSize: '13px' }} />
                        <span>{staging ? 'Staging latest changes…' : 'Stage Latest Changes'}</span>
                    </button>
                </div>
            </div>

            {/* Middle Row: Search Input */}
            <div style={{ marginBottom: '16px', position: 'relative' }}>
                <FaSearch style={{
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#a0aec0',
                    fontSize: '14px',
                }} />
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Search candidate name, email, reference number, external ID, or employee ID…"
                    style={{
                        width: '100%',
                        padding: '10px 40px 10px 38px',
                        fontSize: '14px',
                        border: '1px solid #cbd5e0',
                        borderRadius: '6px',
                        outline: 'none',
                        backgroundColor: '#f7fafc',
                        color: '#2d3748',
                        boxSizing: 'border-box',
                    }}
                />
                {searchQuery && (
                    <button
                        type="button"
                        onClick={() => onSearchChange('')}
                        style={{
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            color: '#a0aec0',
                            cursor: 'pointer',
                            fontSize: '14px',
                            padding: '4px',
                        }}
                        title="Clear search"
                    >
                        <FaTimes />
                    </button>
                )}
            </div>

            {/* Bottom Row: Status Filter Chips */}
            <div style={{
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap',
                alignItems: 'center',
            }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#718096', marginRight: '4px' }}>
                    Status:
                </span>
                {statuses.map((statusKey) => {
                    const isSelected = selectedStatus === statusKey;
                    const count = countFor ? countFor(statusKey) : 0;
                    const label = STATUS_LABELS[statusKey] || statusKey;

                    return (
                        <button
                            key={statusKey}
                            type="button"
                            onClick={() => onStatusChange(statusKey)}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '6px 14px',
                                borderRadius: '20px',
                                fontSize: '13px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                border: isSelected ? '1px solid #2b6cb0' : '1px solid #e2e8f0',
                                backgroundColor: isSelected ? '#ebf8ff' : '#ffffff',
                                color: isSelected ? '#2b6cb0' : '#4a5568',
                                transition: 'all 0.15s ease',
                            }}
                        >
                            <span>{label}</span>
                            <span style={{
                                backgroundColor: isSelected ? '#2b6cb0' : '#edf2f7',
                                color: isSelected ? '#ffffff' : '#718096',
                                borderRadius: '10px',
                                padding: '2px 7px',
                                fontSize: '11px',
                                fontWeight: '700',
                            }}>
                                {count}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default PurgatoryToolbar;
